import React from 'react';
import AuthGate from '@/modules/auth/components/AuthGate';
import { SidebarProvider } from '@/core/context/sidebar/SidebarContext';
import { BreadcrumbProvider } from '@/core/context/breadcrumb/BreadcrumbContext';
import AppLayout from './AppLayout';

const AppLayoutShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <AuthGate>
        <SidebarProvider>
            <BreadcrumbProvider>
                <AppLayout>{children}</AppLayout>
            </BreadcrumbProvider>
        </SidebarProvider>
    </AuthGate>
);

export default AppLayoutShell;
